import React, { useEffect, useState } from "react";
import { Input, Button, Upload, message, Select, Switch, DatePicker } from "antd";
import ImgCrop from "antd-img-crop";
import dayjs from "dayjs";

const CreateEventAdmin = () => {
  const [eventName, setEventName] = useState("");
  const [location, setLocation] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [assignPhotographer, setAssignPhotographer] = useState("");
  const [photographers, setPhotographers] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [showPinInput, setShowPinInput] = useState(false);
  const [clientName, setClientName] = useState("");
const [clientContact, setClientContact] = useState("");


  // Fetch photographers
  useEffect(() => {
    fetch("http://localhost:5000/admin/photographers")
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) setPhotographers(data);
        else message.warning("Failed to fetch photographers");
      })
      .catch(err => {
        message.error("Server error while fetching photographers");
        console.error(err);
      });
  }, []);

  const handleCreateEvent = async () => {
    if (!eventName || !assignPhotographer || !location || !startDate || !endDate) {
      return message.warning("Please fill all required fields.");
    }

    const user = JSON.parse(localStorage.getItem("user"));
    const created_id = user?._id;

    const formData = new FormData();
    formData.append("event_name", eventName);
    formData.append("location", location);
    formData.append("start_date", startDate);
    formData.append("end_date", endDate);
    formData.append("created_id", created_id);
    formData.append("photographer_id", assignPhotographer);
    formData.append("client_name", clientName);
formData.append("client_contact", clientContact);

    if (fileList[0]) {
      formData.append("event_photo", fileList[0].originFileObj);
    }

    try {
      const response = await fetch("http://localhost:5000/admin/create-event", {
        method: "POST",
        body: formData,
      });
      const result = await response.json();

      if (result && result._id) {
        message.success("Event created successfully!");
        setEventName("");
        setLocation("");
        setStartDate(null);
        setEndDate(null);
        setAssignPhotographer("");
        setFileList([]);
      } else {
        message.error(result.message || "Failed to create event.");
      }
    } catch (error) {
      console.error("Event creation failed:", error);
      message.error("Error while creating event.");
    }
  };

  return (
    <div className="container">
      <h2>Create New Event</h2>

      <div className="mb-3">
        <label>Event Name:</label>
        <Input
          placeholder="Enter event name"
          value={eventName}
          onChange={(e) => setEventName(e.target.value)}
        />
      </div>
<div className="mb-3">
  <label>Client Name:</label>
  <Input
    placeholder="Enter client name"
    value={clientName}
    onChange={(e) => setClientName(e.target.value)}
  />
</div>

<div className="mb-3">
  <label>Client Contact:</label>
  <Input
    placeholder="Enter client contact number"
    value={clientContact}
    onChange={(e) => setClientContact(e.target.value)}
  />
</div>

      <div className="mb-3">
        <label>Location:</label>
        <Input
          placeholder="Enter event location"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label>Start Date:</label>
        <DatePicker
          style={{ width: "100%" }}
          value={startDate ? dayjs(startDate) : null}
          onChange={(date) => setStartDate(date?.format("YYYY-MM-DD"))}
          placeholder="Start Date"
        />
      </div>

      <div className="mb-3">
        <label>End Date:</label>
        <DatePicker
          style={{ width: "100%" }}
          value={endDate ? dayjs(endDate) : null}
          onChange={(date) => setEndDate(date?.format("YYYY-MM-DD"))}
          placeholder="End Date"
        />
      </div>

      <div className="mb-3">
        <label>Assign Photographer:</label>
        <Select
          placeholder="Select photographer"
          style={{ width: "100%" }}
          value={assignPhotographer || undefined}
          onChange={(value) => setAssignPhotographer(value)}
        >
          {photographers.map((photographer) => (
            <Select.Option key={photographer._id} value={photographer._id}>
              {photographer.name}
            </Select.Option>
          ))}
        </Select>
      </div>

      

      <div className="mb-3">
        <label>Upload Event Cover:</label>
        <ImgCrop rotationSlider>
          <Upload
            listType="picture-card"
            fileList={fileList}
            onChange={({ fileList: newFileList }) => setFileList(newFileList)}
            onPreview={async (file) => {
              let src = file.url;
              if (!src) {
                src = await new Promise((resolve) => {
                  const reader = new FileReader();
                  reader.readAsDataURL(file.originFileObj);
                  reader.onload = () => resolve(reader.result);
                });
              }
              const image = new Image();
              image.src = src;
              const imgWindow = window.open(src);
              imgWindow?.document.write(image.outerHTML);
            }}
          >
            {fileList.length < 1 && "+ Upload"}
          </Upload>
        </ImgCrop>
      </div>

      <Button type="primary" onClick={handleCreateEvent}>
        Create Event
      </Button>
    </div>
  );
};

export default CreateEventAdmin;
